
  document.oncontextmenu = null;
  window.oncontextmenu = null;

  document.onkeydown = null;
  window.onkeydown = null;

  document.querySelectorAll('*').forEach(el => {
      el.oncontextmenu = null;
      el.onkeydown = null;
  });

  window.addEventListener('contextmenu', e => {
      e.stopImmediatePropagation();
  }, true);

  window.addEventListener('keydown', e => {
      e.stopImmediatePropagation();
  }, true);

  console.log('Right-click blockers removed');



function updateSoldOutStatus() {
    const btn = document.getElementById('product-addcart');
    if (!btn) return;

    fetch(location.pathname + '.js')
        .then(r => r.json())
        .then(product => {
            btn.classList.toggle('sold', !product.available);
            btn.textContent = product.available ? 'Add to cart' : 'Sold Out';
        });
}

updateSoldOutStatus();

window.addEventListener('popstate', updateSoldOutStatus);

const pushState = history.pushState;
history.pushState = function() {
    pushState.apply(history, arguments);
    setTimeout(updateSoldOutStatus, 100);
};

const replaceState = history.replaceState;
history.replaceState = function() {
    replaceState.apply(history, arguments);
    setTimeout(updateSoldOutStatus, 100);
};